import { CurrentUserFragmentFragment, useCurrentUserQuery } from 'generated/graphql'

const useCurrentUser = (): CurrentUserFragmentFragment | null => {
  const { data, loading } = useCurrentUserQuery()

  return !loading && data && data.currentUser ? data.currentUser : null
}

export default useCurrentUser
